import React, { useState } from 'react';
import { Truck, Route, Settings } from 'lucide-react';
import Button from '../../components/ui/Button';
import RangosFleteTab from './RangosFleteTab';
import VehiculosTab from './VehiculosTab';
import './FleteManagementPage.css';

const FleteManagementPage = () => {
    const [activeTab, setActiveTab] = useState('rangos');

    const tabs = [
        {
            id: 'rangos',
            label: 'Rangos de Flete',
            icon: Route,
            component: RangosFleteTab
        },
        {
            id: 'vehiculos',
            label: 'Vehículos',
            icon: Truck,
            component: VehiculosTab
        }
    ];

    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="flete-management-page">
            {/* Header */}

            {/* Pestañas */}
            <div className="flete-tabs">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <Button
                            key={tab.id}
                            variant={activeTab === tab.id ? 'primary' : 'secondary'}
                            onClick={() => setActiveTab(tab.id)}
                            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                        >
                            <Icon size={18} />
                            {tab.label}
                        </Button>
                    );
                })}
            </div>

            {/* Contenido de la pestaña activa */}
            <div className="flete-content">
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default FleteManagementPage;